import { useState } from 'react';

import { Box, Button, Stack, TextField, Typography } from '@mui/material';

import type { CommentFormData } from './types';

interface CommentFormProps {
  readonly onCancel: () => void;
  readonly onSave: (data: CommentFormData) => void;
  readonly isSaving: boolean;
  readonly readOnly: boolean;
}

export function CommentForm({ onCancel, onSave, isSaving, readOnly }: CommentFormProps) {
  const [text, setText] = useState('');

  return (
    <Stack spacing={2}>
      <Box>
        <Typography id="comment-modal-title" variant="h6">
          Add Comment
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Add the same comment to each selected client's page. Comments are not displayed on the Related Client page.
        </Typography>
      </Box>

      <TextField
        label="Comment"
        value={text}
        onChange={(event) => setText(event.target.value)}
        fullWidth
        multiline
        rows={4}
        placeholder="Enter your comment..."
        disabled={isSaving}
        slotProps={{ input: { readOnly } }}
      />

      <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }}>
        <Button variant="outlined" onClick={onCancel} disabled={isSaving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => onSave({ text })} disabled={isSaving || !text.trim()}>
          Add
        </Button>
      </Stack>
    </Stack>
  );
}

export default CommentForm;
